import { resolveIdParam } from '@/components/Functional/utils/resolveIdParam'
import { ScanCodeOverlay } from '@/components/Layout/scanner/components/ScanCodeOverlay'
import type { Result } from '@zxing/library'

type Props = {
  /** オーバーレイの開閉状態 */
  opened: boolean
  /** 閉じる時のコールバック（✕ボタン押下・ブラウザバック） */
  onClose: () => void
  /**
   * QR読み取り成功時のコールバック
   * @param spotId - QRコードから取得したスポットID
   */
  onRead: (spotId: number) => void
  /** 「QRコードを読み込めない方はこちら」押下時のコールバック */
  onManualSelect: () => void
}

/** QRコードテキストから spotId を抽出するユーティリティ */
function extractSpotId(text: string): number | null {
  try {
    // URL パラメータから解決（`id` 優先、次いで `query`）
    const url = new URL(text)
    const result = resolveIdParam(url.searchParams.get('id') ?? undefined, url.searchParams.get('query') ?? undefined)
    if (result !== null) return result
  } catch {
    // URL でない場合は次のパターンへ
  }
  // パターン2: 数値のみ（例: "175"）
  if (/^\d+$/.test(text.trim())) return Number(text.trim())
  return null
}

export function DialogV2CouponQrScan({ opened, onClose, onRead, onManualSelect }: Props) {
  const handleRead = async (result: Result): Promise<boolean> => {
    const spotId = extractSpotId(result.getText())
    if (spotId === null) {
      // フォーマット不一致 → 読み取り継続
      return false
    }
    onRead(spotId)
    // false を返して ScanCodeOverlay の自動 onClose() 呼び出しを抑制する。
    // COUPON_SPOT_SELECTED でステートが couponUse へ遷移すると opened が false になり
    // オーバーレイは自然に閉じるため onClose() は不要。
    return false
  }

  return (
    <div className="relative">
      <ScanCodeOverlay
        opened={opened}
        mode="qr"
        title="スポットのQRコードを読み込んでください"
        onClose={onClose}
        onRead={handleRead}
      />
      {/* 「QRコードを読み込めない方はこちら」ボタン: ScanCodeOverlay の上に z-index で重ねて表示 */}
      {opened && (
        <div className="fixed bottom-[100px] left-0 right-0 z-[1001] flex justify-center">
          <button type="button" className="font-bold text-[14px] text-white underline" onClick={onManualSelect}>
            QRコードを読み込めない方はこちら
          </button>
        </div>
      )}
    </div>
  )
}
